<!--
列表空的提示

使用说明：

<EmptyListTip
 :icon="图标路径"
 :text="提示文本"
 :text2="提示文本2"
 :primaryButton="大按钮文字"
 :primaryButtonLink="大按钮跳转链接"
 :secondButton="小按钮文字"
 :secondButtonLink="小按钮跳转链接"
 />

-->

<template>
    <div class="empty-list-tip-wrap">
        <PromptModal ref="promptModal" :url="url"/>
        <Icon class="icon" :img="icon" />
        <div class="text1">暂无满足兑换条件的商品，去<a href="javascript:;" @click="hanldeGo">赢取积分</a></div>
    </div>
</template>

<script>
import PromptModal from '@/components/kubaolottery/PromptModal'
export default {
  props: ['icon', 'url'],
  components:{PromptModal},
  methods: {
      hanldeGo(){
          this.$refs.promptModal.display();
      }
  }
}
</script>

<style lang="less" scoped>

.empty-list-tip-wrap{
    display: block;
    padding-top: 26vh;

    .icon{
        display: block;
        margin: 0 auto;
        width: 25.33vw;
        height: 25.33vw;
    }

    .text1{
        text-align: center;
        line-height: 13.33vw;
        color: #676767;
        font-size: 4.55vw;

        a{
            color: #ff0129;
        }
    }

    .text2{
        color: #bfbdbe;
        font-size: 3.46vw;
        text-align: center;
        line-height: 1em;
    }

    .button-list{
        margin-top: 18vh;

        .button1{
            background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
            color: #fff;
            height: 12vw;
            width: 92vw;
            line-height: 12vw;
            font-size: 4.26vw;
            border: none;
            display: block;
            margin: 0vw auto;
            border-radius: 6vw;
            text-align: center;
        }

        .button2{
            text-align: center;
            display: block;
            width: 92vw;
            margin: 8.5vw auto 0;
        }
    }

}



</style>





// WEBPACK FOOTER //
// src/components/kubaolottery/GameEmptyListTip.vue